import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { InfoMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import React, {
  lazy,
  Suspense,
  FunctionComponent,
  useRef,
  useCallback,
} from 'react';

import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';
import { usePopover } from '../popover';

const HeaderInfoMenuPopoverPromise = import(/* webpackChunkName: "info-menu-popover" */ 'app/gamma/src/components/popovers/header-info-menu');
const HeaderInfoMenuPopover = lazy(() => HeaderInfoMenuPopoverPromise);

export const InfoMenuButton: FunctionComponent = () => {
  const infoButtonRef = useRef<HTMLButtonElement>(null);
  const { isPopoverShown, showPopover } = usePopover({
    name: InfoMenuPopoverId,
  });

  const onClick = useCallback(
    () => {
      trackUe({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.INFO_MENU,
        method: 'clicking info header button',
      });
      showPopover();
    },
    [showPopover],
  );

  return (
    <>
      <HeaderButton
        icon={IconName.Information}
        onClick={onClick}
        ref={infoButtonRef}
        testId={HeaderTestIds.InfoButton}
      />
      {isPopoverShown && (
        <Suspense fallback={null}>
          <HeaderInfoMenuPopover target={() => infoButtonRef.current} />
        </Suspense>
      )}
    </>
  );
};
